<template>
    <span>
        <b-button variant="danger" @click.stop="abrirModal()" class="ml-2"
            v-if="!desabilitarBotaoCancelarRequisicao">
            <span>
                <i class="fa fa-times-circle"></i>
                Cancelar Solicitação
            </span>
        </b-button>

        <b-modal v-model="mostrarModal" centered>
            <div slot="modal-title">Confirmar Cancelamento da Solicitação</div>

            <b-row>
                <b-col sm="12">
                    <p class="mb-3">
                        Ao cancelar a solicitação, ela será encerrada e não poderá mais ser processada. Confirme para
                        prosseguir.
                    </p>

                    <b-form-group>
                        <label class="d-block">
                            <b-form-checkbox v-model="confirmadoCancelamento" class="d-inline-block align-middle mr-2" />
                            <span class="align-middle">
                                Confirmo o cancelamento da solicitação
                                <span class="text-danger">*</span>
                            </span>
                        </label>
                    </b-form-group>

                </b-col>
            </b-row>

            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()">Fechar</b-button>
                <b-button variant="danger" class="ml-2" :disabled="!confirmadoCancelamento"
                    @click.stop="confirmarCancelarSolicitacao()">
                    Cancelar Solicitação
                </b-button>
            </div>
        </b-modal>

    </span>
</template>

<script>
import RequisicoesServicos from './RequisicoesServicos'

export default {
    props: {
        requisicao: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            mostrarModal: false,
            confirmadoCancelamento: false,
            desabilitarBotaoCancelarRequisicao: true,
        }
    },
    methods: {
        abrirModal() {
            this.confirmadoCancelamento = false
            this.mostrarModal = true
        },
        fecharModal() {
            this.mostrarModal = false
        },
        confirmarCancelarSolicitacao() {
            this.cancelarSolicitacaoRequisicao(this.requisicao.idRequisicao)
            this.fecharModal()
        },
        cancelarSolicitacaoRequisicao(idRequisicao) {
            this.$store.dispatch('addRequest')
            RequisicoesServicos.cancelarRequisicaoSolicitacao(idRequisicao)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Solicitação cancelada com sucesso',
                                'SUCESSO',
                                this.$toastConfig.success
                            )
                        } else {
                            this.$toast.error(
                                'Erro ao cancelar solicitação',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                        this.$emit('atualizarRequisicao')
                    }
                })
                .catch(() => {
                    this.$toast.error(
                        'Erro na comunicação com o servidor',
                        'ERROR',
                        this.$toastConfig.error
                    )
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest')
                })
        },
        deveDesabilitarBotaoCancelarRequisicao() {
            if (!this.requisicao) {
                return true;
            }
            
            const situacaoSolicitacaoCancelada = 4;
            const situacaoSolicitacaoAprovada = 2;
            const emailUsuarioAtual = this.$store.getters.usuario.email;
            const usuarioAtualSolicitante = this.requisicao.emailSolicitante == emailUsuarioAtual;
            const requisicaoAprovadaOuCancelada = this.requisicao.situacaoSolicitacao == situacaoSolicitacaoCancelada || this.requisicao.situacaoSolicitacao == situacaoSolicitacaoAprovada
            
            return requisicaoAprovadaOuCancelada && usuarioAtualSolicitante;
        }
    },
    watch: {
        requisicao: {
            immediate: true,
            handler() {
                this.desabilitarBotaoCancelarRequisicao = 
                this.deveDesabilitarBotaoCancelarRequisicao();
            }
        }
    }
}
</script>
